import { Comment, PaginationParams } from '@arpeggi/shared'
import DraftJS from 'draft-js'

export interface GetCommentsParams extends Omit<PaginationParams<Comment>, 'orderBy'> {
  orderBy?: Pick<Comment, 'createdAt'>
}

export interface CreateCommentDto {
  body: DraftJS.RawDraftContentState
}
